import React, { useState } from 'react';
import { Button, Card, CardBody, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { BidStatus, BidStatusName } from '../constants/BidStatus';
import { SET_SELECTED_BID } from './BidsReducer';

function BidsStatusFilter({ onChangeStatus }) {
  const dispatch = useDispatch();
  const previousSearchParams = useSelector((state) => state.bids.get('bidsSearchParams'));
  const [selected, setSelected] = useState(previousSearchParams?.status || '');

  const handleClick = (status) => {
    dispatch({
      type: SET_SELECTED_BID,
    });
    setSelected(status);
    onChangeStatus(status);
  };

  const getButtonClass = (status) =>
    classNames(status !== selected ? 'btn-soft-primary' : 'btn-primary');

  return (
    <Row>
      <Col md="12">
        <Card>
          <CardBody>
            <div className="d-flex gap-2 flex-wrap">
              <Button
                className={classNames('rounded-pill', getButtonClass(''))}
                onClick={() => handleClick('')}
              >
                All
              </Button>
              {Object.entries(BidStatus).map(([status]) => (
                <Button
                  key={status}
                  className={classNames('rounded-pill', getButtonClass(status))}
                  onClick={() => handleClick(status)}
                >
                  {BidStatusName[status]}
                </Button>
              ))}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

BidsStatusFilter.propTypes = {
  onChangeStatus: PropTypes.func.isRequired,
};

export default BidsStatusFilter;
